import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-opportunity';
import type { SortOption } from '@ctw/shared/content/resource/resource-table-actions';

export const defaultRiskSort: SortOption<RiskGapModel> = {
  display: 'Name (A to Z)',
  sorts: [{ key: 'title', dir: 'asc' }],
};

export const riskSortOptions: Array<SortOption<RiskGapModel>> = [
  defaultRiskSort,
  {
    display: 'Name (Z to A)',
    sorts: [{ key: 'title', dir: 'desc' }],
  },
  {
    display: 'RAF Score (High to Low)',
    sorts: [{ key: 'rafScore', dir: 'desc' }],
  },
  {
    display: 'RAF Score (Low to High)',
    sorts: [{ key: 'rafScore', dir: 'asc' }],
  },
  {
    display: 'Confidence (High to Low)',
    sorts: [{ key: 'confidenceLevel', dir: 'desc' }],
  },
  {
    display: 'Confidence (Low to High)',
    sorts: [{ key: 'confidenceLevel', dir: 'asc' }],
  },
];
